import { Text } from "@mantine/core";

import { toLabResultsNoteHtml } from "@/health-gorilla/utils/lab-results-note";

import classes from "./LabResultsNoteText.module.css";

/** The provider's message to the client about lab results, with its formatting. */
export default function LabResultsNoteText({
  note,
  "aria-label": ariaLabel,
}: LabResultsNoteTextProps) {
  return (
    <Text
      component="div"
      aria-label={ariaLabel}
      className={classes.labResultsNote}
      dangerouslySetInnerHTML={{ __html: toLabResultsNoteHtml(note) }}
    />
  );
}

interface LabResultsNoteTextProps {
  note: string;
  "aria-label"?: string;
}
